import { INK } from '../themeConstants'

export const colorPalette = {
  mode: 'light',
  primary: { main: '#0078d4' },
  error: { main: '#c50f1f' },
  success: { main: '#107c10' },
  warning: { main: '#d83b01' },
  info: { main: '#0078d4' },
  background: {
    default: '#f0eae5',
    paper: '#f9f7f5',
  },
  text: {
    primary: INK.primary,
    secondary: INK.secondary,
    disabled: INK.disabled,
  },
  divider: '#e8ded6',
  action: {
    active: INK.primary,
    hover: '#e8ded6',
    selected: 'rgba(232, 222, 214, 0.65)',
    disabled: INK.disabled,
    disabledBackground: 'rgba(39, 39, 39, 0.08)',
    focus: 'rgba(0, 120, 212, 0.12)',
  },
}
